const styles = {
  '.entity__shield': {
    bgColor: 'bg.primary',
    borderColor: 'bg.primary',
  },
};

export default styles;
